import { Component, h, Host, Prop } from "@stencil/core";

@Component({
    tag: "ux-skeleton",
    styleUrl: "skeleton.scss",
    shadow: true
})
export class UxSkeleton {
    /**
     * Number of skeleton items to render
     */
    @Prop() readonly count: number = 1;

    render() {
        return (
            <Host role="status" aria-live="polite" aria-busy="true">
                {Array.from({ length: this.count }).map(() => (
                    <div class="item" aria-hidden="true"></div>
                ))}
            </Host>
        );
    }
}
